import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import Swiper from 'react-id-swiper';

import LearnMore from 'components/learnMore';
import { Title } from 'components/typography';
import { SWIPER_SETTINGS } from 'config';

import {
  learnMore,
  empathy,
  excellence,
  execution,
  coreValuesSection,
  carouselContainer,
  coreValuesCtaContainer,
} from './scss/CoreValuesSection.module.scss';
import { CAROUSEL_ITEMS } from './CoreValuesSection.constants';

const CoreValuesSection = () => {
  return (
    <section className={coreValuesSection} name="coreValues">
      <Container fluid>
        <Row>
          <Col xs="12" lg="4" className={empathy}>
            <div>
              <Title value="EMPATHY" size="lg" withBorder />
              <p>
                We embrace the intricacies and complexities of the world we live
                in and the people in it. We make the simple choice, daily, to
                promote a community where every player understands their
                importance and can derive deserved value from participating.
              </p>
            </div>
          </Col>
          <Col xs="12" lg="8" className={carouselContainer}>
            <Swiper {...SWIPER_SETTINGS}>
              {CAROUSEL_ITEMS.map((item, index) => (
                <div key={`AFEX_COREVALUE_CAROUSEL_IMAGE_${index}`}>
                  <img src={item.src} alt="Afex carousel" />
                </div>
              ))}
            </Swiper>
          </Col>
        </Row>
        <Row>
          <Col xs="12" lg="4" className={excellence}>
            <div>
              <Title value="EXCELLENCE" size="lg" withBorder />
              <p>
                We understand the importance of our work and its effect on the
                world. We bring to work, daily, an exemplary passion and drive
                to do it the best way that we can and even then to consistently
                improve upon it.
              </p>
            </div>
          </Col>
          <Col xs="12" lg="4" className={execution}>
            <div>
              <Title value="EXECUTION" size="lg" withBorder />
              <p>
                We believe that ideas must go beyond our imaginations or
                scribbled thoughts to exist in the real world. We appreciate
                innovative and creative thinking, but prefer the magic of
                getting things done.
              </p>
            </div>
          </Col>
          <Col lg="4" className={coreValuesCtaContainer}>
            <LearnMore
              className={learnMore}
              context="OUR CORE VALUES"
              theme="regular"
              arrowType="primary"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CoreValuesSection;
